import React, {useState} from 'react'
import {
  Card,
  Col,
  Container,
  Form,
  Image,
  Row,
  OverlayTrigger,
  Popover
} from 'react-bootstrap'
import {useDispatch, useSelector} from 'react-redux'
import Book from '../../../assets/icons/book.svg'
import Window from '../../../assets/icons/window.svg'
import InfoCircle from '../../../assets/icons/info-circle-fill.svg'
import {
  updateCareplanAction,
  updateCareplanOpportunity,
  updateCareplanRule,
  updateCareplanSubAction
} from '../../../redux/actions/ccp'
import {formatRuleActions} from '../../../utils/helpers'

const CarePlan = () => {
  const [showClinical, setShowClinical] = useState(false)
  const [showPatientEd, setShowPatientEd] = useState(false)
  const [activeRuleId, setRuleId] = useState(-1)

  const dispatch = useDispatch()
  const {opportunities, rules, actions, encounter, subActions} = useSelector((state) => ({
    opportunities: state.ccp.opportunities,
    rules: state.ccp.rules,
    actions: state.ccp.actions,
    activeKey: state.header.activeKey,
    encounter: state.patient.encounter,
    subActions: state.ccp.subActions
  }))

  const handleShowClinical = (ruleId) => {
    setRuleId(ruleId)
    setShowClinical(true)
  }

  const handleCloseClinical = () => {
    setShowClinical(false)
  }

  const handleShowPatientEd = (ruleId) => {
    setRuleId(ruleId)
    setShowPatientEd(true)
  }

  const handleClosePatientEd = () => {
    setShowPatientEd(false)
  }

  return (
    <div>
      <h2>Step 2: Collaborative Care Plan</h2>
      <Container fluid className='border'>
        <Row>
          <Col>
            <Container id='ccp' fluid className='shadow-sm my-2 pb-2'>
              <Form id='ccp'>
                <Form.Row className='border-bottom mt-2'>
                  <Col xs={12}>
                    <h3 className='h5'>Care Opportunities</h3>
                  </Col>
                </Form.Row>
                {
                  opportunities.map((opportunity) => (
                    <div key={`opportunity-${opportunity.opportunityId}`}>
                      {
                        opportunity.ruleIds.length > 0 && (
                          <Form.Row className="border-bottom mb-1">
                            <Card
                              className={`${opportunity.checked ? 'bg-light ' : ''}w-100 border-0`}>
                              <Card.Header
                                className={`${opportunity.checked ? 'bg-light ' : ''}border-0`}>
                                <div className='custom-control custom-switch'>
                                  <input
                                    type='checkbox'
                                    className='custom-control-input'
                                    id={opportunity.name}
                                    name={opportunity.opportunityId}
                                    disabled={encounter.status.status === 'FINISHED'}
                                    checked={opportunity.checked}
                                    onChange={(event) => dispatch(updateCareplanOpportunity(event.target))}
                                  />
                                  <label
                                    className={`custom-control-label${!opportunity.checked ? ' text-muted' : ' font-weight-bold'} h6`}
                                    htmlFor={opportunity.name}
                                  >
                                    {opportunity.name}
                                  </label>
                                </div>
                              </Card.Header>
                              {
                                opportunity.checked && (
                                  <Card.Body style={{
                                    marginTop: -15
                                  }}>
                                    <Row>
                                      <Col xs={4}>
                                        <h3 className='h4'>Recommendations</h3>
                                      </Col>
                                      <Col xs={2}/>
                                      <Col xs={6}>
                                        <h3 className='h4 ml-2'>
                                                                                    Actions
                                        </h3>
                                      </Col>
                                    </Row>
                                    {
                                      opportunity.checked > 0 && opportunity.ruleIds.map((ruleId) => {
                                        const rule = rules.find((r) => r.ruleId === ruleId)
                                        const {
                                          patientEds,
                                          ruleActions
                                        } = formatRuleActions(rule, actions)
                                        const clinicalPopover = (
                                          <Popover
                                            id='popover'
                                            className='ccp-popover'
                                          >
                                            <Popover.Content
                                              onMouseEnter={() => handleShowClinical(ruleId)}
                                              onMouseLeave={handleCloseClinical}
                                            >
                                              {
                                                rule.clinicalContent.map((clinicalContent, index) => (
                                                  <div
                                                    key={`opportunity-${opportunity.opportunityId}-content-${clinicalContent.contentId}`}
                                                    className='mb-2'>
                                                    {index + 1}. <a
                                                      href={clinicalContent.content.url}
                                                      target='_blank'
                                                      rel='noreferrer'>{clinicalContent.content.title}</a>
                                                  </div>
                                                ))
                                              }
                                            </Popover.Content>
                                          </Popover>
                                        )

                                        const patientEdPopover = (
                                          <Popover
                                            id='popover'
                                            className='ccp-popover'
                                          >
                                            <Popover.Content
                                              onMouseEnter={() => handleShowPatientEd(ruleId)}
                                              onMouseLeave={handleClosePatientEd}
                                            >
                                              {
                                                patientEds.map((patientEd, index) => (
                                                  <div
                                                    key={`opportunity-${opportunity.opportunityId}-patientEd-${patientEd.id}`}
                                                    className='mb-2'>
                                                    {index + 1}. {patientEd.url ?
                                                      <a href={patientEd.url}
                                                        target='_blank'
                                                        rel='noreferrer'>{patientEd.title}</a> : patientEd.title}
                                                  </div>
                                                ))
                                              }
                                            </Popover.Content>
                                          </Popover>
                                        )

                                        const ruleChecked = opportunity.activeRuleIds.includes(rule.ruleId)
                                        return (
                                          <div
                                            key={`opportunity-${opportunity.opportunityId}-rule-${ruleId}`}>
                                            <Row className='mb-2'>
                                              <Col xs={5}>
                                                <div
                                                  className='custom-control custom-switch'>
                                                  <input
                                                    type='checkbox'
                                                    className='custom-control-input'
                                                    id={rule.name}
                                                    name={rule.ruleId}
                                                    disabled={encounter.status.status === 'FINISHED'}
                                                    checked={ruleChecked}
                                                    onChange={(event) => dispatch(updateCareplanRule(event.target))}
                                                  />
                                                  <label
                                                    className={`custom-control-label${!ruleChecked ? ' text-muted' : ' font-weight-bold'}`}
                                                    htmlFor={rule.name}
                                                  >
                                                    {rule.shortName}
                                                  </label>
                                                </div>
                                                <div style={{
                                                  marginLeft: 35
                                                }}>
                                                  <OverlayTrigger
                                                    placement='right'
                                                    overlay={
                                                      <Popover>
                                                        <Popover.Content
                                                          className='text-center'>
                                                          {rule.name}
                                                        </Popover.Content>
                                                      </Popover>
                                                    }
                                                  >
                                                    <Image src={InfoCircle}
                                                      alt='More Info'
                                                      className={`mr-2${!ruleChecked ? ' filter-grey' : ''}`}/>
                                                  </OverlayTrigger>
                                                  {
                                                    rule.clinicalContent.length > 0
                                                      ? (
                                                        <OverlayTrigger
                                                          show={activeRuleId === rule.ruleId && showClinical}
                                                          placement='right'
                                                          overlay={clinicalPopover}
                                                        >
                                                          <Image
                                                            src={Book}
                                                            alt={opportunity.name}
                                                            onMouseEnter={() => handleShowClinical(ruleId)}
                                                            onMouseLeave={handleCloseClinical}
                                                            className="mr-1"
                                                          />
                                                        </OverlayTrigger>
                                                      )
                                                      : null
                                                  }
                                                  {
                                                    patientEds.length > 0
                                                      ? (
                                                        <OverlayTrigger
                                                          show={activeRuleId === rule.ruleId && showPatientEd}
                                                          placement='right'
                                                          overlay={patientEdPopover}
                                                        >
                                                          <Image
                                                            src={Window}
                                                            alt='Patient Ed'
                                                            onMouseEnter={() => handleShowPatientEd(ruleId)}
                                                            onMouseLeave={handleClosePatientEd}
                                                            className="ml-1"
                                                          />
                                                        </OverlayTrigger>
                                                      )
                                                      : null
                                                  }
                                                </div>
                                              </Col>
                                              <Col xs={1}/>
                                              <Col xs={6}>
                                                {
                                                  ruleActions.map((action) => {
                                                    const actionChecked = rule.activeActionIds.includes(action.key)
                                                    return (
                                                      <div
                                                        key={`opportunity-${opportunity.opportunityId}-rule-${ruleId}-action-${action.key}`}>
                                                        <div
                                                          className='custom-control custom-switch'
                                                        >
                                                          <input
                                                            type='checkbox'
                                                            className='custom-control-input'
                                                            id={`${rule.ruleId} ${action.actionId}`}
                                                            name={action.key}
                                                            disabled={encounter.status.status === 'FINISHED'}
                                                            checked={actionChecked}
                                                            onChange={(event) => dispatch(updateCareplanAction(event.target, rule.ruleId))}
                                                          />
                                                          <label
                                                            className={`custom-control-label${!actionChecked ? ' text-muted' : ' font-weight-bold'}`}
                                                            htmlFor={`${rule.ruleId} ${action.actionId}`}
                                                          >
                                                            {action.description}
                                                          </label>
                                                        </div>
                                                        {
                                                          action.subActionIds.map((subAction) => {
                                                            const foundAction = subActions.find((a) => a.key === subAction)
                                                            const subActionChecked = foundAction ? rule.activeSubActionIds.includes(foundAction.key) : false
                                                            return (
                                                              <div
                                                                key={`opportunity-${opportunity.opportunityId}-rule-${ruleId}-action-${action.key}-subAction-${foundAction.key}`}>
                                                                {
                                                                  foundAction !== undefined ? (
                                                                    <div
                                                                      className='custom-control custom-switch ml-5'
                                                                    >
                                                                      <input
                                                                        type='checkbox'
                                                                        className='custom-control-input'
                                                                        id={`${rule.ruleId}-${action.actionId}-${foundAction.actionId}`}
                                                                        name={foundAction.key}
                                                                        disabled={encounter.status.status === 'FINISHED'}
                                                                        checked={subActionChecked}
                                                                        onChange={(event) => dispatch(updateCareplanSubAction(event.target, rule.ruleId, action.actionId))}
                                                                      />
                                                                      <label
                                                                        className={`custom-control-label${!subActionChecked ? ' text-muted' : ' font-weight-bold'}`}
                                                                        htmlFor={`${rule.ruleId}-${action.actionId}-${foundAction.actionId}`}
                                                                      >
                                                                        {foundAction.description}
                                                                      </label>
                                                                    </div>
                                                                  ) : null
                                                                }
                                                              </div>
                                                            )
                                                          })
                                                        }
                                                      </div>
                                                    )
                                                  })
                                                }
                                              </Col>
                                            </Row>
                                            <hr style={{borderTop: '1px solid #7fb8d2'}}/>
                                          </div>
                                        )
                                      })
                                    }
                                  </Card.Body>
                                )
                              }
                            </Card>
                          </Form.Row>
                        )
                      }
                    </div>
                  ))
                }
              </Form>
            </Container>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default CarePlan
